import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSection, TutorialSlide } from "../../tutorial.models";


export const NOTE_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'Welcome-Notes',
        title: 'Note Settings! 👋',
        messages: [{ text: "With MedicAI, you'll never have to write a medical note again! However, how you prefer to write your notes is a very personal choice influenced by various factors. By customizing your note settings, your AI Assistant can generate notes that align with your preferences." }],
        actions: [
            {
                text: 'Get Started',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DEFAULT_NOTES_ADDED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.CUSTOM_NOTES_ADDED, type: SlideHideConditionType.AND },
        ],
    },
    {
        key: 'Add-defNotes',
        title: 'Default Note Types',
        messages: [
            { text: "We offer several default note types for common medical consultations to help you get started. Take a look at the headings under each note type — they're completely customizable! You can swap out headings, edit them, re-order them, or even delete them altogether. Plus, you can add subheadings to better structure your AI-generated notes." },
        ],
        expansionTarget: 'AI_NOTE',
        highlightTarget: 'AI_NOTE',
        forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DEFAULT_NOTES_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-defNotes',
        messages: [
            { text: "We recommend that, as you begin using MedicAI and familiarize yourself with how your notes are generated by your AI Assistant, you revisit this menu to customize the output to better suit your needs. " },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DEFAULT_NOTES_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-cusNotes',
        title: 'Custom Note Types',
        expansionTarget: 'CUSTOM_NOTE',
        highlightTarget: 'CUSTOM_NOTE',
        //forceOpenTarget: true,
        messages: [
            { text: "We get that every medical specialty has its own vibe, and each practice interacts with patients in its own way. That's why we've created custom note types to help you personalize your notes for specific situations. For instance, you can design a note structure just for a migraine consultation or a transplant clinic evaluation — it's totally up to you! Your AI Assistant will effortlessly use this note structure for the right consultations." },
            { text: "Start by clicking \"+\" to create a new note." },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
                
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CUSTOM_NOTES_ADDED, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-cusNotes',
        // title: 'Custom Note Types',
        keepDialogOpen: true,
        videoUrl: 'https://www.youtube.com/watch?v=84PthVIrnPA',
        thumbnailUrl: 'assets/notes-thumbnail.png',
        messages: [

            { text: "Click on the video above to learn how to add custom note types!" },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.CUSTOM_NOTES_ADDED, type: SlideHideConditionType.OR },
        ],

    },
    {
        key: 'Notes-Finish',
        title: 'Completed Notes Settings!',
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' },
        dimensions: { width: '450px' },
        messages: [{ text: "You are 45% done!" }],
        actions: [
            {
                text: 'Carry on - Recommended',
                color: 'primary',
                actionName: SlideAction.START_SCHEDULE_TUTORIAL,
            },
            {
                text: 'Continue Later',
                color: 'warn',
                actionName: SlideAction.CLOSE_TUTORIAL,
                suffixText: 'Continue Later'
            },

        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        progressBar: 45,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DEFAULT_NOTES_ADDED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.CUSTOM_NOTES_ADDED, type: SlideHideConditionType.AND },
        ],
    },
];